import React, { forwardRef } from 'react';
import { ChevronLeftIcon } from '@heroicons/react/outline';
import TextLink from './TextLink';
import Button from './Button';
import Menu from './Menu';
import { cn } from './cn';
import useViewport from '../hooks/useViewport';

/** Back navigation owns its icon and appearance; callers own the destination. */
const BackButton = forwardRef(function BackButton(
  { children = 'Back', menu = false, labelHidden = false, compactOnMobile = true, closeOnSelect = true, className, ...props },
  ref
) {
  const { isMobile } = useViewport();
  if (menu) {
    return (
      <Menu.Item {...props} icon={ChevronLeftIcon} closeOnSelect={closeOnSelect} className={className}>
        {children}
      </Menu.Item>
    );
  }

  if (labelHidden || (compactOnMobile && isMobile)) {
    return (
      <Button {...props} variant="ghost" iconOnly ref={ref} className={cn('shrink-0', className)}>
        <ChevronLeftIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="sr-only">{children}</span>
      </Button>
    );
  }

  return (
    <TextLink
      as="button"
      {...props}
      ref={ref}
      muted
      size="meta"
      className={cn('gap-1.5 disabled:cursor-not-allowed disabled:opacity-50', className)}
    >
      <ChevronLeftIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
      {children}
    </TextLink>
  );
});

export default BackButton;
